// LICENSE_CODE ZON
'use strict'; /*jslint react:true es6:true*/
import React from 'react';
import escape from '/util/escape.js';
import {OAUTH_PROVIDER} from '../../shared/constants.js';
import {wrap_url_prefix, get_embedded_data} from '../../util.js';
import {Button} from '../button';

const OKTA_CID = get_embedded_data('okta_cid', null);

const OAUTH_META = {
    [OAUTH_PROVIDER.GOOGLE]: {
        name: 'Google',
        ico: 'ico_google',
    },
    [OAUTH_PROVIDER.GITHUB]: {
        name: 'Github',
        ico: 'ico_github',
    },
    [OAUTH_PROVIDER.OKTA]: {
        name: 'okta',
        ico: 'ico_okta',
    },
};
export const OAUTH_ACTION = {
    SIGNIN: 'login',
    SIGNUP: 'signup',
};

const get_oauth_url = (opts={})=>{
    const {action=OAUTH_ACTION.SIGNIN, provider, recaptcha_token} = opts;
    const url_base = wrap_url_prefix('/users');
    const auth_qs = {action, sdk: true};
    if (recaptcha_token)
        auth_qs.recaptcha = recaptcha_token;
    const {origin} = window.location;
    let suffix = '';
    if (provider==OAUTH_PROVIDER.OKTA)
        suffix += `/${OKTA_CID}`;
    return escape.uri(`${origin}${url_base}/auth/${provider}${suffix}`,
        auth_qs);
};

export function Oauth_button({
    className,
    provider,
    action,
    recaptcha_token,
    size='m',
})
{
    if (provider==OAUTH_PROVIDER.OKTA && !OKTA_CID)
        return null;
    const meta = OAUTH_META[provider];
    const url = get_oauth_url({action, provider, recaptcha_token});
    const prefix = action==OAUTH_ACTION.SIGNIN
        ? 'Log in with '
        : 'Sign up with ';
    const label = `${prefix}${meta.name}`;
    return <Button className={className} ico={meta.ico}
      size={size} in_new_tab={false} href={url}
      track_event={`${action}_${provider}_oauth_click`}>
      {label}
    </Button>;
}
